import React, { useState } from 'react'
// import faqImg from '../assets/website/faq-img.png'



export default function Faq() {
  const [open, setOpen] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
 
  return (
    <>
      <div className='w-full p-4 py-20'>
       

        {/* new faq  */}
        <section className="">
          <h4 className="lg:text-3xl text-2xl lg:font-semibold text-center">
            Frequently Asked Questions
          </h4>
          <p className='pt-4 pb-15 text-center pb-10'>Still wondering how LNVS Fintech works? Here’s what you need to know.</p>


          <div className="max-w-5xl mx-auto  py-15 shadow-lg rounded-lg py-7 px-7">

            {/* FAQ Item 1 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 1 ? null : 1)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> Is LNVS Fintech compliant with RBI and financial regulations ?  </span>
                <span className={`transition-transform duration-300 ${open === 1 ? "rotate-45" : ""}`}> +  </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 1 ? "px-6 pb-4" : "max-h-0"}`} >
                <p className="text-gray-600 lg:text-base sm:text-sm">
                  Yes. Our platform is built with regulatory compliance at its core - supporting RBI guidelines, data localization norms, and audit-ready reporting for banks and NBFCs operating in regulated environments. </p>

              </div>
            </div>

            {/* FAQ Item 2 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 2 ? null : 2)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> How fast does LNVS Fintech process a loan application?  </span>
                <span className={`transition-transform duration-300 ${open === 2 ? "rotate-45" : ""}`} >  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 2 ? "px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600 lg:text-base sm:text-sm">
                   Our AI decisioning engine processes and approves loan applications in as little as 10 minutes - from document verification to final disbursal - with zero manual intervention required. </p>
                

              </div>
            </div>

            {/* FAQ Item 3 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 3 ? null : 3)}
                className="w-full flex justify-between items-center px-6 py-4 text-left">
                <span className="font-medium text-gray-800 lg:text-lg">  Can LNVSTech handle high loan volumes?  </span>
                <span className={`transition-transform duration-300 ${open === 3 ? "rotate-45" : ""}`}>  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 3 ? "max-h-40 px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600"> Our scalable infrastructure is built to support high-volume lending operations while maintaining speed, reliability, and performance. </p>
              </div>
            </div>

            {/* FAQ Item 4 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 4 ? null : 4)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> Does LNVSTech help reduce lending risk ?  </span>
                <span className={`transition-transform duration-300 ${open === 4 ? "rotate-45" : ""}`} >  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 4 ? "px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600">
                  Yes. Advanced analytics, risk intelligence, and fraud detection tools help lenders assess borrower profiles more accurately and minimize portfolio risk. </p>

              </div>
            </div>

            {/* FAQ Item 5 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 5 ? null : 5)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> What types of verification services does LNVSTech support ?   </span>
                <span className={`transition-transform duration-300 ${open === 5 ? "rotate-45" : ""}`} >  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 5 ? "px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600">
                  Our platform supports digital KYC, identity verification, document verification, bank account validation, and other essential checks required for modern lending.
             
             </p> 
             </div>
            </div>

             {/* FAQ Item 6 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 6 ? null : 6)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> Does LNVS Fintech support eKYC and video KYC ?   </span>
                <span className={`transition-transform duration-300 ${open === 6 ? "rotate-45" : ""}`} >  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 6 ? "px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600">
                  Yes. Our identity verification stack supports Aadhaar-based eKYC, PAN verification, face match, and video KYC - fully compliant with UIDAI and RBI guidelines for seamless digital onboarding.
             </p> 
             </div>
            </div>

             {/* FAQ Item 7 */}
            <div className="border rounded-lg bg-white mb-4">
              <button onClick={() => setOpen(open === 7 ? null : 7)}
                className="w-full flex justify-between items-center px-6 py-4 text-left" >
                <span className="font-medium text-gray-800 lg:text-lg"> What support does LNVS Fintech provide post-integration ?   </span>
                <span className={`transition-transform duration-300 ${open === 7 ? "rotate-45" : ""}`} >  + </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${open === 7 ? "px-6 pb-4" : "max-h-0"}`}>
                <p className="text-gray-600">
                 We offer dedicated onboarding support, 24/7 technical assistance, regular model retraining, and quarterly performance reviews — ensuring your lending stack stays optimized as your business scales. </p> 
             </div>
            </div>

         

          </div>
        </section>
        {/* end */}

      </div>
    </>
  )
}
